<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Set Payment Processor Fee Account</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="conn.accounting_software === AccountingSoftwareType.none">
    <div class="form-group">
      <label for="inputDepositAccountId">Deposit Account ID</label>
      <input type="text" class="form-control"
             id="inputDepositAccountId" name="inputDepositAccountId"
             [(ngModel)]="selectedAccount.account_id">
    </div>
    <div class="form-group">
      <label for="inputDepositAccountCode">Deposit Account Code</label>
      <input type="text" class="form-control"
             id="inputDepositAccountCode" name="inputDepositAccountCode"
             [(ngModel)]="selectedAccount.account_code">
    </div>
    <div class="form-group">
      <label for="inputDepositAccountName">Deposit Account Name</label>
      <input type="text" class="form-control"
             id="inputDepositAccountName" name="inputDepositAccountName"
             [(ngModel)]="selectedAccount.account_name">
    </div>
  </div>

  <div class="modal-body" *ngIf="conn.accounting_software !== AccountingSoftwareType.none">
    <h3 *ngIf="loadingAccounts" class="text-secondary">Loading accounts...</h3>

    <ng-container *ngIf="!loadingAccounts">
      <p>Select which account will be used as the deposit account:</p>

      <p *ngIf="accounts.length === 0">No accounts found</p>

      <div class="form-check" *ngFor="let account of accounts">
        <input class="form-check-input" type="radio" name="selectedAccount"
               id="selectedAccount{{ account.account_id }}"
               [value]="account" [(ngModel)]="selectedAccount">
        <label class="form-check-label" for="selectedAccount{{ account.account_id }}">
          <span *ngIf="account.account_code">{{ account.account_code }} -</span>
          {{ account.account_name }}
          <span *ngIf="account.account_type">({{ account.account_type }})</span>
        </label>
      </div>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary"
            (click)="handleSubmit()"
            [disabled]="selectedAccount === null"
            [class.disabled]="selectedAccount === null"
            *ngIf="!loadingSave">
      Save
    </button>
    <button class="btn btn-primary disabled" type="button" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
